/* Weight Estimator Config — auto-generated from production data */
window.__WEIGHT_ESTIMATOR_CONFIG__ = {
  "FR-01": {
    "category": "Sim Beadlock Fixed",
    "method": "regression_6lug",
    "coef_diameter": 1.3966,
    "coef_width": 0.7034,
    "intercept": -17.0122,
    "r2": 0.578,
    "mae_kg": 0.38,
    "n_configs": 23,
    "min_diameter": 17.0,
    "max_diameter": 18.0,
    "min_width": 8.5,
    "max_width": 9.5
  },
  "FR-01BL": {
    "category": "True Beadlock",
    "method": "regression_6lug",
    "coef_diameter": 1.3728,
    "coef_width": 0.9426,
    "intercept": -18.7353,
    "r2": 0.961,
    "mae_kg": 0.32,
    "n_configs": 6,
    "min_diameter": 17.0,
    "max_diameter": 20.0,
    "min_width": 8.5,
    "max_width": 10.5
  },
  "FR-01R": {
    "category": "Sim Beadlock Removable",
    "method": "regression_6lug",
    "coef_diameter": 1.5224,
    "coef_width": 0.6006,
    "intercept": -19.2177,
    "r2": 0.856,
    "mae_kg": 0.69,
    "n_configs": 48,
    "min_diameter": 17.0,
    "max_diameter": 22.0,
    "min_width": 8.0,
    "max_width": 10.0
  },
  "FR-05": {
    "category": "Sim Beadlock Fixed",
    "method": "regression_6lug",
    "coef_diameter": 0.8585,
    "coef_width": -1.2829,
    "intercept": 9.0817,
    "r2": 0.515,
    "mae_kg": 0.45,
    "n_configs": 4,
    "min_diameter": 17.0,
    "max_diameter": 20.0,
    "min_width": 8.5,
    "max_width": 10.0
  },
  "FR-05BL": {
    "category": "True Beadlock",
    "method": "limited",
    "avg_weight_kg": 12.9,
    "avg_diameter": 17.0,
    "avg_width": 8.5,
    "n_configs": 1,
    "min_diameter": 17.0,
    "max_diameter": 17.0,
    "min_width": 8.5,
    "max_width": 8.5
  },
  "FR-05R": {
    "category": "Sim Beadlock Removable",
    "method": "limited",
    "avg_weight_kg": 14.6,
    "avg_diameter": 18.5,
    "avg_width": 9.5,
    "n_configs": 2,
    "min_diameter": 17.0,
    "max_diameter": 20.0,
    "min_width": 9.0,
    "max_width": 10.0
  },
  "FR-06": {
    "category": "Sim Beadlock Fixed",
    "method": "limited",
    "avg_weight_kg": 12.25,
    "avg_diameter": 17.0,
    "avg_width": 9.0,
    "n_configs": 1,
    "min_diameter": 17.0,
    "max_diameter": 17.0,
    "min_width": 9.0,
    "max_width": 9.0
  },
  "FR-10": {
    "category": "Sim Beadlock Fixed",
    "method": "limited",
    "avg_weight_kg": 12.8,
    "avg_diameter": 17.0,
    "avg_width": 8.5,
    "n_configs": 1,
    "min_diameter": 17.0,
    "max_diameter": 17.0,
    "min_width": 8.5,
    "max_width": 8.5
  },
  "FR-10R": {
    "category": "Sim Beadlock Removable",
    "method": "limited",
    "avg_weight_kg": 14.93,
    "avg_diameter": 18.5,
    "avg_width": 9.25,
    "n_configs": 2,
    "min_diameter": 17.0,
    "max_diameter": 20.0,
    "min_width": 8.5,
    "max_width": 10.0
  },
  "FR-11": {
    "category": "Sim Beadlock Fixed",
    "method": "regression_6lug",
    "coef_diameter": 1.1092,
    "coef_width": 0.1346,
    "intercept": -7.2106,
    "r2": 0.867,
    "mae_kg": 0.41,
    "n_configs": 19,
    "min_diameter": 17.0,
    "max_diameter": 20.0,
    "min_width": 8.0,
    "max_width": 10.0
  },
  "FR-11R": {
    "category": "Sim Beadlock Removable",
    "method": "regression_6lug",
    "coef_diameter": 1.1478,
    "coef_width": 0.6333,
    "intercept": -12.9098,
    "r2": 0.969,
    "mae_kg": 0.38,
    "n_configs": 34,
    "min_diameter": 15.0,
    "max_diameter": 24.0,
    "min_width": 8.0,
    "max_width": 12.0
  },
  "FR-12": {
    "category": "Sim Beadlock Fixed",
    "method": "regression_6lug",
    "coef_diameter": 0.7102,
    "coef_width": 1.3246,
    "intercept": -9.7513,
    "r2": 0.733,
    "mae_kg": 0.78,
    "n_configs": 13,
    "min_diameter": 17.0,
    "max_diameter": 22.0,
    "min_width": 8.5,
    "max_width": 10.0
  },
  "FR-12R": {
    "category": "Sim Beadlock Removable",
    "method": "regression_6lug",
    "coef_diameter": 1.0271,
    "coef_width": 1.8078,
    "intercept": -21.0565,
    "r2": 0.875,
    "mae_kg": 0.65,
    "n_configs": 17,
    "min_diameter": 17.0,
    "max_diameter": 20.0,
    "min_width": 8.5,
    "max_width": 10.0
  },
  "FR-13": {
    "category": "Sim Beadlock Fixed",
    "method": "regression_6lug",
    "coef_diameter": 1.2586,
    "coef_width": -0.9376,
    "intercept": -0.1215,
    "r2": 0.959,
    "mae_kg": 0.23,
    "n_configs": 7,
    "min_diameter": 17.0,
    "max_diameter": 20.0,
    "min_width": 8.5,
    "max_width": 9.5
  },
  "FR-13R": {
    "category": "Sim Beadlock Removable",
    "method": "regression_6lug",
    "coef_diameter": 0.9961,
    "coef_width": 0.9881,
    "intercept": -13.0606,
    "r2": 0.966,
    "mae_kg": 0.45,
    "n_configs": 7,
    "min_diameter": 17.0,
    "max_diameter": 22.0,
    "min_width": 8.5,
    "max_width": 10.0
  },
  "FR-18": {
    "category": "Sim Beadlock Fixed",
    "method": "regression_6lug",
    "coef_diameter": 1.8,
    "coef_width": 0.85,
    "intercept": -25.25,
    "r2": 1.0,
    "mae_kg": 0.01,
    "n_configs": 4,
    "min_diameter": 16.0,
    "max_diameter": 17.0,
    "min_width": 8.0,
    "max_width": 9.0
  },
  "FR-18EXO": {
    "category": "Smooth Lip",
    "method": "limited",
    "avg_weight_kg": 11.7,
    "avg_diameter": 17.0,
    "avg_width": 8.5,
    "n_configs": 2,
    "min_diameter": 17.0,
    "max_diameter": 17.0,
    "min_width": 8.5,
    "max_width": 8.5
  },
  "FR-18R": {
    "category": "Sim Beadlock Removable",
    "method": "regression_6lug",
    "coef_diameter": 1.0942,
    "coef_width": 0.9891,
    "intercept": -15.0198,
    "r2": 0.881,
    "mae_kg": 0.63,
    "n_configs": 9,
    "min_diameter": 17.0,
    "max_diameter": 22.0,
    "min_width": 8.5,
    "max_width": 10.0
  },
  "FR-19": {
    "category": "Sim Beadlock Fixed",
    "method": "regression_6lug",
    "coef_diameter": 1.3131,
    "coef_width": 1.3456,
    "intercept": -21.3885,
    "r2": 0.964,
    "mae_kg": 0.3,
    "n_configs": 13,
    "min_diameter": 17.0,
    "max_diameter": 20.0,
    "min_width": 8.5,
    "max_width": 10.0
  },
  "FR-19BL": {
    "category": "True Beadlock",
    "method": "limited",
    "avg_weight_kg": 13.95,
    "avg_diameter": 17.0,
    "avg_width": 9.75,
    "n_configs": 2,
    "min_diameter": 17.0,
    "max_diameter": 17.0,
    "min_width": 9.0,
    "max_width": 10.5
  },
  "FR-19R": {
    "category": "Sim Beadlock Removable",
    "method": "regression_6lug",
    "coef_diameter": 1.1285,
    "coef_width": 0.7083,
    "intercept": -12.2712,
    "r2": 0.939,
    "mae_kg": 0.37,
    "n_configs": 25,
    "min_diameter": 17.0,
    "max_diameter": 22.0,
    "min_width": 8.5,
    "max_width": 12.0
  },
  "FRS-01": {
    "category": "Smooth Lip",
    "method": "regression_6lug",
    "coef_diameter": 1.519,
    "coef_width": 1.0864,
    "intercept": -24.4264,
    "r2": 0.758,
    "mae_kg": 0.55,
    "n_configs": 14,
    "min_diameter": 17.0,
    "max_diameter": 20.0,
    "min_width": 8.5,
    "max_width": 9.5
  },
  "FRS-05": {
    "category": "Smooth Lip",
    "method": "limited",
    "avg_weight_kg": 12.77,
    "avg_diameter": 17.0,
    "avg_width": 8.5,
    "n_configs": 1,
    "min_diameter": 17.0,
    "max_diameter": 17.0,
    "min_width": 8.5,
    "max_width": 8.5
  },
  "FRS-06": {
    "category": "Smooth Lip",
    "method": "regression_6lug",
    "coef_diameter": 1.5625,
    "coef_width": 0.25,
    "intercept": -17.925,
    "r2": 1.0,
    "mae_kg": 0.0,
    "n_configs": 3,
    "min_diameter": 18.0,
    "max_diameter": 22.0,
    "min_width": 9.0,
    "max_width": 10.0
  },
  "FRS-08": {
    "category": "Smooth Lip",
    "method": "regression_6lug",
    "coef_diameter": 0.775,
    "coef_width": 0.0,
    "intercept": -1.8,
    "r2": 0.997,
    "mae_kg": 0.03,
    "n_configs": 3,
    "min_diameter": 18.0,
    "max_diameter": 20.0,
    "min_width": 8.5,
    "max_width": 9.0
  },
  "FRS-11": {
    "category": "Smooth Lip",
    "method": "regression_6lug",
    "coef_diameter": 0.8464,
    "coef_width": 1.8589,
    "intercept": -19.9476,
    "r2": 0.98,
    "mae_kg": 0.13,
    "n_configs": 5,
    "min_diameter": 17.0,
    "max_diameter": 20.0,
    "min_width": 8.5,
    "max_width": 9.0
  },
  "FRS-12": {
    "category": "Smooth Lip",
    "method": "regression_6lug",
    "coef_diameter": 0.9595,
    "coef_width": 0.4912,
    "intercept": -9.795,
    "r2": 0.866,
    "mae_kg": 0.46,
    "n_configs": 30,
    "min_diameter": 17.0,
    "max_diameter": 22.0,
    "min_width": 8.5,
    "max_width": 14.0
  },
  "FRS-18": {
    "category": "Smooth Lip",
    "method": "limited",
    "avg_weight_kg": 11.95,
    "avg_diameter": 19.0,
    "avg_width": 9.25,
    "n_configs": 2,
    "min_diameter": 17.0,
    "max_diameter": 21.0,
    "min_width": 8.5,
    "max_width": 10.0
  },
  "RT-10R": {
    "category": "Sim Beadlock Removable",
    "method": "limited",
    "avg_weight_kg": 13.45,
    "avg_diameter": 17.0,
    "avg_width": 9.0,
    "n_configs": 1,
    "min_diameter": 17.0,
    "max_diameter": 17.0,
    "min_width": 9.0,
    "max_width": 9.0
  },
  "RT-12R": {
    "category": "Sim Beadlock Removable",
    "method": "limited",
    "avg_weight_kg": 16.95,
    "avg_diameter": 20.0,
    "avg_width": 9.0,
    "n_configs": 1,
    "min_diameter": 20.0,
    "max_diameter": 20.0,
    "min_width": 9.0,
    "max_width": 9.0
  },
  "SS-01": {
    "category": "Smooth Lip",
    "method": "limited",
    "avg_weight_kg": 11.38,
    "avg_diameter": 17.0,
    "avg_width": 8.75,
    "n_configs": 2,
    "min_diameter": 17.0,
    "max_diameter": 17.0,
    "min_width": 8.5,
    "max_width": 9.0
  },
  "TX-01": {
    "category": "Sim Beadlock Fixed",
    "method": "regression_6lug",
    "coef_diameter": 1.05,
    "coef_width": -0.7,
    "intercept": 0.95,
    "r2": 0.985,
    "mae_kg": 0.03,
    "n_configs": 4,
    "min_diameter": 17.0,
    "max_diameter": 18.0,
    "min_width": 8.0,
    "max_width": 9.0
  },
  "TX-01BL": {
    "category": "True Beadlock",
    "method": "limited",
    "avg_weight_kg": 12.55,
    "avg_diameter": 18.0,
    "avg_width": 9.25,
    "n_configs": 2,
    "min_diameter": 18.0,
    "max_diameter": 18.0,
    "min_width": 9.0,
    "max_width": 9.5
  },
  "TX-01R": {
    "category": "Sim Beadlock Removable",
    "method": "regression_6lug",
    "coef_diameter": 0.896,
    "coef_width": 0.22,
    "intercept": -4.958,
    "r2": 0.878,
    "mae_kg": 0.45,
    "n_configs": 10,
    "min_diameter": 17.0,
    "max_diameter": 20.0,
    "min_width": 8.5,
    "max_width": 10.0
  },
  "TXS-01": {
    "category": "Smooth Lip",
    "method": "regression_6lug",
    "coef_diameter": 1.9,
    "coef_width": 1.0,
    "intercept": -30.8,
    "r2": 1.0,
    "mae_kg": 0.0,
    "n_configs": 3,
    "min_diameter": 17.0,
    "max_diameter": 20.0,
    "min_width": 8.5,
    "max_width": 9.0
  },
  "XR-01": {
    "category": "Sim Beadlock Fixed",
    "method": "limited",
    "avg_weight_kg": 13.05,
    "avg_diameter": 17.0,
    "avg_width": 9.0,
    "n_configs": 2,
    "min_diameter": 17.0,
    "max_diameter": 17.0,
    "min_width": 8.5,
    "max_width": 9.5
  },
  "XR-01R": {
    "category": "Sim Beadlock Removable",
    "method": "regression_6lug",
    "coef_diameter": 1.6714,
    "coef_width": 0.1468,
    "intercept": -16.883,
    "r2": 0.997,
    "mae_kg": 0.15,
    "n_configs": 10,
    "min_diameter": 17.0,
    "max_diameter": 24.0,
    "min_width": 8.5,
    "max_width": 9.5
  },
  "XR-03R": {
    "category": "Sim Beadlock Removable",
    "method": "limited",
    "avg_weight_kg": 16.65,
    "avg_diameter": 20.0,
    "avg_width": 10.0,
    "n_configs": 1,
    "min_diameter": 20.0,
    "max_diameter": 20.0,
    "min_width": 10.0,
    "max_width": 10.0
  },
  "XRS-01": {
    "category": "Smooth Lip",
    "method": "limited",
    "avg_weight_kg": 10.83,
    "avg_diameter": 17.0,
    "avg_width": 8.5,
    "n_configs": 3,
    "min_diameter": 17.0,
    "max_diameter": 17.0,
    "min_width": 8.5,
    "max_width": 8.5
  }
};
